/* eslint-disable no-console */
import type { AxiosResponse } from 'axios';

import { useCallback } from 'react';

import client from 'state/remote/client';

import { useApiDiplomaRemoveDelete } from 'state/__generated__/tadaahAPI';

const useDeleteFreelancerPersonRegisterDocument = (): {
  deletePersonRegisterDocument: (
    diplomaId: string,
  ) => Promise<AxiosResponse<void>>;
  isLoading: boolean;
  error: null | Error;
  isSuccess: boolean;
  resetDeletionStatus: () => void;
} => {
  const { mutateAsync, isLoading, error, isSuccess, reset } =
    useApiDiplomaRemoveDelete({
      mutation: {
        mutationKey: 'delete-freelancer-person-register-document',
        onSuccess: () => {
          const queriesToInvalidate = [
            'freelancer-documents',
            'freelancer-person-register-document',
            'freelancer-profile',
            'freelancer-details',
          ];
          queriesToInvalidate.forEach((query) => {
            client.invalidateQueries(query);
          });
        },
      },
    });

  const deletePersonRegisterDocument = useCallback(
    async (diplomaId: string) => {
      let response: AxiosResponse = {
        config: {},
        data: {},
        headers: {},
        request: {},
        status: 202,
        statusText: 'OK',
      };

      try {
        response = await mutateAsync({ id: diplomaId });
        if (response.status !== 204) {
          throw new Error('Something went wrong');
        }
      } catch (err) {
        console.log('Something went wrong');
      }

      return response;
    },
    [mutateAsync],
  );

  return {
    deletePersonRegisterDocument,
    error,
    isLoading,
    isSuccess,
    resetDeletionStatus: reset,
  };
};

export default useDeleteFreelancerPersonRegisterDocument;
